import React, {useEffect, useState, useCallback} from "react";
import {Translation, useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {setHeader} from "../../../../redux/actions/layout/interaction/action";
import {
    changeStatusOnLeaveConfigApi,
    deleteOnLeaveConfigApi,
    loadOnLeaveConfig
} from "../../../../api/setting/timekeeping/annual-leave";
import {Modal, Switch} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import CommonList from "../../../../common/list";
import TableTitle from "../../../../common/list/components/TableTitle";
import TableMenu from "../../../../common/list/components/TableMenu";
import {useNavigate, useSearchParams} from "react-router-dom";
import {font_icon} from "../../../../common/column";
import {debounce} from "lodash/function";
import {DELAY_DEBOUNCE} from "../../../../common/config-variable/notification";

function OnLeaveConfigList(props) {
    const {t} = useTranslation();
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [totalCount, setTotalCount] = useState(0)

    useEffect(() => {
        setLoading(true)
        dispatch(setHeader(t("layout.annualLeave"), null));

        loadOnLeaveConfig({
            search : searchParams.get("search"),
            page : searchParams.get("page"),
            pageSize : searchParams.get("pageSize"),
        }).then(data => {
            setDataSource(mapData(data.items));
            setTotalCount(data.totalCount)
        }).finally(() => setLoading(false))
    }, [searchParams.get("search"), searchParams.get("page"), searchParams.get("pageSize")]);

    function checkStatus(status) {
        let to = "";
        if (status === "pending") to = t("benefitData.pending");
        else if (status === "approved") to = t("benefitData.approved");
        else if (status === "reject") to = t("benefitData.reject");
        else if (status === "trashed") to = t("benefitData.disable");
        return to;
    }

    const loadDataSource = () => {
        setLoading(true)
        loadOnLeaveConfig({
            search : searchParams.get("search"),
            page : searchParams.get("page"),
            pageSize : searchParams.get("pageSize"),
        }).then(data => {
            setDataSource(mapData(data.items));
            setTotalCount(data.totalCount)
        }).finally(() => setLoading(false))
    }

    const debouncedDelete = useCallback(
        debounce((id) => {
            return deleteOnLeaveConfigApi(id).then(() => {
                loadDataSource()
            })
        }, DELAY_DEBOUNCE),
        []);

    const handleDelete = (id) => {
        debouncedDelete(id)
    };

    const onDelete = (id, name) => {
        Modal.confirm({
            content: <span> {t("tnp.button.confirmRemove")}<span
                className={"font-bold"}>{name}</span> {t("tnp.button.no")}</span>,
            icon: null,
            width: 500,
            okText: t("tnp.button.delete"),
            cancelText:  t("tnp.button.cancelText"),
            onOk: () => {
                handleDelete(id)
            },
        })

    }

    const onUpdateStatus = (id, status) => {
        changeStatusOnLeaveConfigApi(id, status).then(() => {
            loadDataSource()
        }).catch(() => {
        })
    }
    const mapData = (onLeaveConfigs) => {
        if (!onLeaveConfigs) {
            return [];
        }

        return onLeaveConfigs?.map((item) => {
            const positionApllication = item?.onLeaveConfigDepartments?.length > 0 ? item?.onLeaveConfigDepartments?.map((position, index) => {
                return (
                    position.name
                );
            }).join(", ") : t("benefitData.positionDepartment");

            return {
                key: item.id,
                id: item.id,
                name: item.name,
                positionApllication,
                numberOfLeaveDay: item.maximumLeave > 1
                    ? `${item.maximumLeave} ${t("leaveSetting.days")}/${t("leaveSetting.year")}`
                    : `${item.maximumLeave} ${t("leaveSetting.day")}/${t("leaveSetting.year")}`,
                status: checkStatus(item.status),
                menu:
                    <TableMenu
                        items={[
                            {
                                key: "approval",
                                // originalIcon: <MoneyCollectOutlined style={{fontSize: font_icon}}/>,
                                originalIcon: <Switch defaultChecked={item.status === "approved"} style={{fontSize: font_icon}}/>,
                                onClick: () => {
                                    item.status === "approved" ? onUpdateStatus(item.id, "trashed") : onUpdateStatus(item.id, "approved")
                                },
                                hint: (item.status && item.status === "approved") ? t("leaveSetting.disable") : t("leaveSetting.enable")
                            },
                            {
                                key: "update",
                                originalIcon: <EditOutlined style={{fontSize: font_icon}}/>,
                                onClick: () => navigate(`/setting/timekeeping/annual-leave/update/${item?.id}`),
                                hint: t("tnp.button.update")
                            },
                            {
                                key: "delete",
                                originalIcon: <DeleteOutlined style={{fontSize: font_icon}}/>,
                                onClick: () => onDelete(item?.id, item.name),
                                hint: t("tnp.button.delete")
                            },
                        ]}/>
            }
        });
    };

    return (
        <div className={'h-full overflow-hidden'}>
            <TableTitle
                title={t("tnp.components.timekeeping.text68")}
            />
            <CommonList
                columns={columns}
                dataSource={dataSource}
                totalCount={totalCount}
                loading={loading}
            />
        </div>
    );
}

const columns = [
    // {
    //     title: "ID",
    //     dataIndex: "id",
    //     width: "8%"
    // },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("leave-setting.leaveSettingName")}</span>}
            </Translation>
        ),
        dataIndex: "name",
        width: "22%"
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span>{t("leave-setting.positionApllication")}</span>}
            </Translation>
        ),
        dataIndex: "positionApllication",
        width: "35%"
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span> {t("leave-setting.numberOfLeaveDay")}</span>}
            </Translation>
        ),
        dataIndex: "numberOfLeaveDay",
        width: "15%"
    },
    {
        title: (
            <Translation>
                {(t, {i18n}) => <span> {t("leave-setting.status")}</span>}
            </Translation>
        ),
        dataIndex: "status",
        width: "15%"
    },
    {
        dataIndex: "menu",
        width: "15%"
    }
];

export default OnLeaveConfigList;
